/**
 * Gestion du bloc Vidéo & Témoignages
 * - Slider de citations avec navigation par points + autoplay
 * - Façade vidéo YouTube (lecture au clic)
 */

class VideoTestimonialsSlider {
    constructor(container) {
        this.container    = container;
        this.slider       = container.querySelector('.video-testimonials__slider');
        this.facade       = container.querySelector('.video-testimonials__video-facade');
        this.currentIndex = 0;
        this.autoplayTimer = null;

        this.init();
    }

    init() {
        if (this.slider) {
            this.initSlider();
        }
        if (this.facade) {
            this.initVideoFacade();
        }
    }

    // --- Slider ---

    initSlider() {
        this.items = Array.from(this.slider.querySelectorAll('.testimonial-item'));
        this.dots  = Array.from(this.slider.querySelectorAll('.video-testimonials__dot'));

        if (this.items.length <= 1) return;

        this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                this.stopAutoplay();
                this.goTo(i);
                this.startAutoplay();
            });
        });

        this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
        this.slider.addEventListener('mouseleave', () => this.startAutoplay());

        this.startAutoplay();
    }

    goTo(index) {
        if (index === this.currentIndex) return;

        // Masquer l'item courant
        this.items[this.currentIndex].classList.remove('is-active');
        if (this.dots[this.currentIndex]) {
            this.dots[this.currentIndex].classList.remove('is-active');
            this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
        }

        // Afficher le nouvel item
        this.currentIndex = index;
        this.items[this.currentIndex].classList.add('is-active');
        if (this.dots[this.currentIndex]) {
            this.dots[this.currentIndex].classList.add('is-active');
            this.dots[this.currentIndex].setAttribute('aria-selected', 'true');
        }
    }

    startAutoplay() {
        if (this.items && this.items.length <= 1) return;
        this.autoplayTimer = setInterval(() => {
            const next = (this.currentIndex + 1) % this.items.length;
            this.goTo(next);
        }, 5000);
    }

    stopAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
    }

    // --- Vidéo YouTube (façade) ---

    initVideoFacade() {
        const videoId = this.facade.getAttribute('data-video-id');
        if (!videoId) return;

        this.facade.addEventListener('click', () => {
            if (this.facade.classList.contains('is-playing')) return;

            const iframe = document.createElement('iframe');
            iframe.src              = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
            iframe.allow            = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.allowFullscreen  = true;
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('title', 'Vidéo YouTube');

            this.facade.appendChild(iframe);
            this.facade.classList.add('is-playing');
        });
    }
}

function initVideoTestimonials() {
    document.querySelectorAll('.video-testimonials').forEach(container => {
        if (!container.dataset.vtInit) {
            container.dataset.vtInit = '1';
            new VideoTestimonialsSlider(container);
        }
    });
}

document.addEventListener('DOMContentLoaded', initVideoTestimonials);

if (typeof jQuery !== 'undefined') {
    jQuery(document).ajaxComplete(initVideoTestimonials);
}
